import './utils/ajax';
import Form from '../../modules/core/forms/theme/js/Form';
import Utils from '../../modules/utils/utils-js/theme/js/utils/Utils';
import Testimonials from './utils/Testimonials';
import Utils2 from './utils/Utils';
import Cart from './Cart';
import Uploader from '../../modules/utils/uploader2/theme/js/Uploader';
import Chat from './chat/Chat';
import JsEval from '../../modules/utils/utils-js/theme/js/JsEval';
import EventView from './views/EventView';
import Translator from './utils/Translator';
import MainSlider from './widgets/MainSlider';
import { createPinia, getActivePinia, setActivePinia } from 'pinia';
import { sympomedStore } from './SympomedStorage';
import Captcha from './utils/Captcha';

declare global {
    interface JQuery {
        slick: any;
    }

    interface Window {
        smpmdpg: number;
    }
}

export class Site {
    public static pinia;

    public static Cart = Cart;

    public static SLIDER_PREV = `<button type="button" class="slick-prev slick-navi slick-navi--std"><i class="fa fa-chevron-left"></i></button>`;
    public static SLIDER_NEXT = `<button type="button" class="slick-next slick-navi slick-navi--std"><i class="fa fa-chevron-right"></i></button>`;

    public static views = {
        EventView,
    };

    public static widgets = {
        MainSlider,
    };

    private static forms = {};

    public static createAction(name: string, data1?: string, data2?: string, success?: (r) => void): void {
        const $header = $('.vevent__header');

        const wseventid = $header.data('id') ? $header.data('id') : null;
        const termid = $header.data('term') ? $header.data('term') : null;

        let data = {
            wsevent: wseventid,
            term: termid,
            data1: data1,
            data2: data2,
        };

        $.ajax({
            url: '/useraction/create/' + name,
            method: 'post',
            data: data,

            success: (r) => {
                if (success) {
                    success(r);
                }
            },

            error: (xhr) => {
            }
        });
    }

    public static initPings(): void {
        setInterval(() => {
            this.createAction('ping', window.location.href, null, (r) => {
                window.smpmdpg = Date.now();
            });
        }, 60 * 1000);
    }

    private static initUserActionsParent($parent?: JQuery): void {
        $('a, button', $parent).on('click', function (e) {
            const $target = $(this);

            let data1 = $target.text().trim();
            let data2 = `<${$target.get(0).tagName} class="${$target.attr('class')}">`;

            Site.createAction('click', data1, data2);
        });

        $(':input', $parent).on('change', function (e) {
            const $form = $(this).closest('form');

            const name = $form.data('action-name');

            if (name) {
                if (!Site.forms[name]) {
                    Site.forms[name] = true;
                    Site.createAction('form.start', name);
                }
            }
        })
    }

    private static initUserActions(): void {
        let scroll30 = false;
        let scroll60 = false;
        let scroll90 = false;

        $(window).on('scroll', (e) => {
            const top = $(window).scrollTop();
            const vh = $('body').height() - window.innerHeight;

            if (!scroll30 && top / vh > 0.3) {
                this.createAction('scroll', '30');
                scroll30 = true;
            }

            if (!scroll60 && top / vh > 0.6) {
                this.createAction('scroll', '60');
                scroll60 = true;
            }

            if (!scroll90 && top / vh > 0.9) {
                this.createAction('scroll', '90');
                scroll90 = true;
            }
        });
    }

    public static setJobsInputs($uid: JQuery): void {
        let $title = $('.js-job-title', $uid);
        let $ititle = $('select', $title);

        let $pwz = $('.js-job-pwz', $uid);
        let $spec = $('.js-job-spec', $uid);

        let $spec2 = $('.js-job-spec2', $uid);
        let $ispec2 = $('select', $spec2);

        let $spec2other = $('.js-job-spec2-other', $uid);

        function update(force?: boolean): void {
            Utils2.toggle($pwz, $ititle.val() != 5, force);
            Utils2.toggle($spec, $ititle.val() != 5, force);
            Utils2.toggle($spec2, $ititle.val() == 5, force);
            Utils2.toggle($spec2other, $ititle.val() == 5 && $ispec2.val() == 5, force);
        }

        $title.on('change', () => {
            update();
        });

        $spec2.on('change', () => {
            update();
        });

        update(true);
    }

    public static async onContactForm($uid: JQuery) {
        const publickey = $uid.data('recaptcha');

        if (publickey) {
            await Captcha.init(publickey)
        }

        (<any>$uid).form({
            before_submit: async () => {
                if (publickey) {
                    const token = await Captcha.submit(publickey);

                    const $itoken = $(`<input type="hidden" name="recaptcha" value="" />`);
                    $itoken.val(token);
                    $uid.prepend($itoken);
                }
            },
        });

        Site.discover($uid);
    }

    public static onPartners($uid: JQuery): void {
        const $list = $('.partners__list', $uid);
        const $items = $('.partners__item', $uid);

        const size = $uid.hasClass('partners--size3') ? 3 : $uid.hasClass('partners--size4') ? 4 : $uid.hasClass('partners--size5') ? 5 : null;

        const initSliderFunc = () => {
            let options = {
                dots: false,
                arrows: true,

                focusOnSelect: true,
                accessibility: false,

                slidesToShow: size,
                slidesToScroll: size - 2,

                autoplay: true,

                prevArrow: this.SLIDER_PREV,
                nextArrow: this.SLIDER_NEXT,

                responsive: [],
            };

            switch (size) {
                case 3:
                    options.responsive.push({
                        breakpoint: 1100,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                        }
                    });
                    options.responsive.push({
                        breakpoint: 790,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        }
                    });
                    break;

                case 4:
                    options.responsive.push({
                        breakpoint: 1375,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                        }
                    });
                    options.responsive.push({
                        breakpoint: 1000,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                        }
                    });
                    options.responsive.push({
                        breakpoint: 730,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        }
                    });
                    break;

                case 5:
                    options.responsive.push({
                        breakpoint: 1090,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 2,
                        }
                    });
                    options.responsive.push({
                        breakpoint: 890,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                        }
                    });
                    options.responsive.push({
                        breakpoint: 700,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                        }
                    });
                    options.responsive.push({
                        breakpoint: 520,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        }
                    });
                    break;
            }

            $list.slick(options);
        };

        if ($uid.hasClass('partners--slider')) {
            if ($items.length > size) {
                initSliderFunc();
            } else {
                $uid.removeClass('partners--slider');
                $uid.addClass('partners--list');
            }
        } else if ($uid.hasClass('partners--auto')) {
            const vw = window.innerWidth;

            if (vw <= 1024 && $items.length > 1) {
                $uid.addClass('partners--slider');
                initSliderFunc();
            } else {
                $uid.addClass('partners--list');
            }
        }
    }

    public static onOrderFiles($uid: JQuery): void {
        const $bfiles = $('.order-files__button--file', $uid);

        $bfiles.on('click', (e) => {
            const $files = $('.order-files__inner', $uid);
            $files.slideToggle();
        });
    }

    public static onPanelAbstractForm($uid: JQuery, prefix: string, uploads: any): void {
        const $list = $('.panelabstractform__files-list', $uid);
        const $addfile = $('.panelabstractform__files-addfile', $uid);
        const $form = $('form', $uid);
        const $submit = $('.submit__input', $form);

        const id = $form.data('id');

        let uploadcount = 0;

        const updateLayout = () => {
            $submit.prop('disabled', uploadcount > 0);
        };

        $.each(uploads, (ix, upload) => {
            const $uploader = $('<div>');
            const uploader = new Uploader($uploader, upload.id);
            uploader.setMaxSize(1024 * 1024 * 3);
            uploader.setTitle(upload.name);

            $uploader.insertBefore($addfile);

            uploader.onSelect((file: FormDataEntryValue) => {
                uploadcount ++;

                updateLayout();
            });

            uploader.onFail(() => {
                uploadcount --;

                updateLayout();
            });

            uploader.onDone(() => {
                uploadcount --;

                updateLayout();
            });
        });

        $addfile.on('click', (e) => {
            const name = prefix + Date.now();

            e.preventDefault();

            const $uploader = $('<div>');
            $uploader.hide();
            $uploader.insertBefore($addfile);

            const uploader = new Uploader($uploader, name);
            uploader.setMaxSize(1024 * 1024 * 3);

            uploader.onRemove(() => {
                // $uploader.fadeOut();
            });

            uploader.onSelect((file: FormDataEntryValue) => {
                $uploader.fadeIn();
                uploadcount ++;

                updateLayout();
            });

            uploader.onFail(() => {
                uploadcount --;

                updateLayout();
            });

            uploader.onDone(() => {
                uploadcount --;

                updateLayout();
            });

            uploader.browse();
        });

        (<any> $uid).form();

        this.discover($uid);
    }

    public static onRegisterForm($uid: JQuery): void {
        this.setJobsInputs($uid);
        this.discover($uid);

        (<any> $uid).form();
    }

    public static onPanelAddressForm($uid: JQuery): void {
        this.setJobsInputs($uid);
        this.discover($uid);

        (<any> $uid).form();
    }

    public static onPanelInvoice($uid: JQuery): void {
        (<any> $uid).form();

        let $invoice = $('.panelinvoiceform__invoice input');
        let $inner = $('.panelinvoiceform__inner');

        $invoice.change((e) => {
            Utils2.toggle($inner, $invoice.is(':checked'));
        });

        Utils2.toggle($inner, $invoice.is(':checked'), true);
    }

    public static onPanelOrders(): void {
    }

    public static onPageCalendar(): void {
        $(() => {
            let $form = $('form.eventsfilters__options');

            let $inputs = $(':input', $form);

            $inputs.on('change', () => {
                let data = $form.serializeArray();
                const url = '/' + $('html').prop('lang') + '/kalendarz/filters';

                $.post(url, data, (r) => {
                    if (r.url) {
                        window.location.href = r.url;
                    }
                });
            });
        });
    }

    public static onPageEvents(): void {
        $(() => {
            let $form = $('form.eventsfilters__options');

            let $inputs = $(':input', $form);

            $inputs.on('change', () => {
                let data = $form.serializeArray();
                let lang = $('html').prop('lang');

                let url = null;

                switch (lang) {
                    case 'pl':
                        url = '/wydarzenia/filters';
                        break;

                    case 'en':
                        url = '/en/events/filters';
                        break;

                }

                $.post(url, data, (r) => {
                    if (r.url) {
                        window.location.href = r.url;
                    }
                });
            });
        });
    }

    public static onPageHome(): void {

    }

    public static discover($parent?: JQuery): void {
        Utils.updateElements($parent);

        this.initUserActionsParent($parent);
    }

    private static updateFloat() {
        var $header=$('.header');

        var top=$(window).scrollTop();
        var wh=$(window).height();

        $('body').toggleClass('body--float', top > 0);
        $('body').toggleClass('body--no-float', top == 0);
        $('body').toggleClass('body--no-float-100', top <= wh);
        $('body').toggleClass('body--float-100', top > wh);
        $('body').toggleClass('body--float-ac', top > wh - 130);
    }

    private static initSearch(): void {
        let $header = $('.header');
        let $search = $('.header__search');
        let $input = $('.header__search-input', $search);
        let $button = $('.header__searchbutton-button');

        $button.on('click', () => {
            $header.toggleClass('header--search-opened');

            $input.focus();
            $input.select();
        });
    }

    private static initHtml() {
        var $mainmenu=$('.mainmenu');

        $('.menubutton', $mainmenu).click(function(e) {
            e.preventDefault();

            $mainmenu.toggleClass('mainmenu--opened', !$mainmenu.hasClass('mainmenu--opened'))
            $('body').toggleClass('body--menuopened', $mainmenu.hasClass('mainmenu--opened'))
        });

        let $accountmenubutton = $('.accountmenu--user .accountmenu__button');

        $accountmenubutton.click((e) => {
            let wx = $(window).width();

            if (wx < 1020) {
                e.preventDefault();
            }
        });

        this.initSearch();

        this.discover();
    }

    private static initRwd() {
        var $header = $('.header');
        $header.addClass('header--noanim');

        $(window).resize(Site.updateFloat);
        $(window).scroll(Site.updateFloat);

        Site.updateFloat();

        $header.removeClass('header--noanim');
    }

    public static initChat($uid: JQuery) {
        $(() => {
            new Chat($uid);
        });
    }

    public static init() {
        (<any> window).Site = Site;

        Site.pinia = createPinia();

        setActivePinia(Site.pinia);

        sympomedStore().init();

        Site.initPings();
        Site.initUserActions();

        Form.init();
        JsEval.init();

        $(document).ready(() => {
            Site.initHtml();
            Site.initRwd();
        });

        Testimonials.init();
        // Translator.init();

        $(window).on('load', () => {
            $('body').addClass('body--loaded');

            setTimeout(() => {
                $('body').removeClass('body--loading');
                $('body').trigger('pageloaded');
            }, 1000);
        });
    }
}

Site.init();
